import { useEffect } from "react";

const useScrollLock = (isOpen) => {
  useEffect(() => {
    if (!isOpen) return;

    const scrollY = window.scrollY;

    // Lock
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";

    return () => {
      // Unlock
      const y = document.body.style.top;

      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";

      window.scrollTo(0, parseInt(y || "0") * -1);
    };
  }, [isOpen]);
};

export default useScrollLock;
